export default __webpack_public_path__ + "static/media/Walker's Belt of the Clans.3c3733d4.jpg";